import styled from "@emotion/styled"
import ContainerWrapper from "pazChargeComponents/general/ContainerWrapper"
import { NewText, extractProperty } from "ui"
import StationTypeCardCharge from "./ServiceTypeCardCharge"

const StyledStationTitleWrapper = styled.div`
  padding-top: 50px;
  padding-bottom: 40px;
  display: flex;
  align-items: center;
  ${(props) => props.theme.breakpoints.down("md")} {
  padding-top: 0px;
    flex-direction: column;
    align-items: start;
  }
`
const StyledLine = styled.div`
  border: 2px solid black;
  width: 28px;
  height: 1px;
  margin-left: -35px;
  margin-right: 10px;
  ${(props) => props.theme.breakpoints.down("md")} {
    margin-left: 0px;
  }
`
const StyledServiceTypeWrapper = styled.div`
  display: grid;
  justify-content: center;
  gap: 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-bottom: 50px;
    grid-template-columns: repeat(2, max-content);
      justify-content: start;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    grid-template-columns: repeat(3, max-content);
  }
`
const StyledWrapper = styled.div`
`
type StationTypeChargeProps = {
  data: any
}
function StationTypeCharge({ data }: StationTypeChargeProps) {
  const title = extractProperty(data, "title")
  const serviceTypeLisy = extractProperty(data, "serviceTypeLisy")

  return (
    <StyledWrapper>
      <ContainerWrapper>
        <StyledStationTitleWrapper>
          <StyledLine />
          <NewText
            desktopFontSize={34}
            desktopLineHeight={"36px"}
            desktopFontWeight={500}
            mobileFontSize={24}
            mobileLineHeight={"28px"}
            mobileFontWeight={500}
            component={"h2"}
          >
            {title}
          </NewText>
        </StyledStationTitleWrapper>
        <StyledServiceTypeWrapper>
          {[...serviceTypeLisy].map((service: any, index: number) => <StationTypeCardCharge key={index} data={service} />)}
        </StyledServiceTypeWrapper>
      </ContainerWrapper>
    </StyledWrapper>
  );
}

export default StationTypeCharge;
